"use client";
import Pagination from "@/components/pagination/pagination";
import { SortDropDown } from "@/components/sortDropdown/sortDropdown";
import { Items } from "@/components/items/items";
import { useTranslations } from "next-intl";
import { useEffect, useRef } from "react";
import useSWR from "swr";
import { getRetailUncategorizedItemsAction } from "../../[slug]/actions";

export const UncatergorizedContainer = ({
  merchantId,
  searchParams,
  currentPage,
  totalPages,
  items,
  pageSize,
  itemTemplate = "Image Focused",
  styles,
  totalItemCount,
  isSimpleStorefront,
  merchantName,
}: any) => {
  const t = useTranslations("UncategorizedContainer");
  const headerRef = useRef<HTMLHeadingElement>(null);

  const { data: swrData } = useSWR(
    merchantId
      ? [
          "retailUncategorizedItems",
          merchantId,
          JSON.stringify(searchParams ?? {}),
        ]
      : null,
    () => getRetailUncategorizedItemsAction(merchantId, searchParams ?? {}),
    {
      fallbackData: {
        data: {
          elements: items,
          currentPage,
          totalPages,
          totalItemCount,
        },
      },
      revalidateOnMount: false,
      revalidateOnFocus: true,
    }
  );

  const activeItems = swrData?.data?.elements ?? items;
  const activeCurrentPage = swrData?.data?.currentPage ?? currentPage;
  const activeTotalPages = swrData?.data?.totalPages ?? totalPages;
  const activeTotalItemCount = swrData?.data?.totalItemCount ?? totalItemCount;

  useEffect(() => {
    if (headerRef.current) {
      headerRef.current.focus();
    }
  }, []);

  return (
    <div className="flex flex-col px-6 sm:px-12 pb-12 pt-6">
      <div className="flex flex-col sm:flex-row w-full justify-between gap-4 mb-4">
        <h2
          ref={headerRef}
          tabIndex={-1}
          className="font-semibold text-[30px] leading-[45px] outline-none"
        >
          {t("uncategorizedItems")}
        </h2>
        {!isSimpleStorefront && <SortDropDown />}
      </div>
      <Items {...{ itemTemplate, items: activeItems, styles, merchantName }} />
      <Pagination
        currentPage={activeCurrentPage}
        totalPages={activeTotalPages}
        pageSize={pageSize}
        itemCount={activeItems.length}
        totalItemCount={activeTotalItemCount}
      />
    </div>
  );
};
